import React from "react";
import constants from "../../../constants";
import MockTestLibraryHooks from "../../../Hooks/Mock/Student/MockTestLibraryHooks";
import Button from "../../Button";
import Tooltip from "../../CommonComponents/Tooltip";
export default function MockTestLibraryCards(Props) {
  const MockTestLibraryHks = MockTestLibraryHooks();

  return (
    <div key={Props.test.id} className="mockTestLibraryGrid">
      <div className="mockTestLibraryGridHeader">
        <div className="mockTestLibraryGridHeaderTitle">{Props.test.name}</div>
      </div>
      <div className="mockTestLibraryDetails">
        <div className="mockTestLibraryGridSubHeader">
          <div className="mockTestLibraryGridSubHeaderTestTitle">
            {MockTestLibraryHks.getTestType(Props.test)}
            <div className="mockTestLibraryGridSubHeaderTestQuestionCount">
              ({Props.test.questionscount} Questions)
            </div>
          </div>
          {/* <div className="mockTestLibraryGridSubHeaderTestDuration">
            {MockTestLibraryHks.getTime(Props.test.testduration)}
          </div> */}
        </div>
        <Tooltip title={Props.test.description} position="top" maxChars={300} theme="light">
        <div className="mockTestLibraryGridTestDescription">
          {Props.test.description}
        </div>
        </Tooltip>
        <div className="mockTestLibraryGridTestTagsDiv">
          {Props.test.hasOwnProperty("tags") &&
            Props.test.tags !== "" &&
            Props.test.tags !== null &&
            Props.test.tags !== "null" && (
              <div className="mockTestLibraryGridTestTags">
                {Props.test.tags}
              </div>
            )}
        </div>
      </div>
      <div className="mockTestLibraryGridFooter">
        <div className="mockTestLibraryGridSubHeaderTestDuration">
            {MockTestLibraryHks.getTime(Props.test.testduration)}
        </div>
        <Button
          size="sm"
          onClick={() => MockTestLibraryHks.handleTest(Props.test)}
          icon={{
                type: "trailing",
                icon: Props.test.videoqn === 1 ? (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.3346 7.44277C18.3346 6.93792 18.3346 6.6855 18.2348 6.56861C18.1482 6.46719 18.0182 6.41337 17.8853 6.42383C17.732 6.43589 17.5535 6.61438 17.1966 6.97136L14.168 9.99996L17.1966 13.0286C17.5535 13.3855 17.732 13.564 17.8853 13.5761C18.0182 13.5866 18.1482 13.5327 18.2348 13.4313C18.3346 13.3144 18.3346 13.062 18.3346 12.5572V7.44277Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M1.66797 8.16663C1.66797 6.7665 1.66797 6.06643 1.94045 5.53165C2.18014 5.06124 2.56259 4.67879 3.03299 4.43911C3.56777 4.16663 4.26784 4.16663 5.66797 4.16663H10.168C11.5681 4.16663 12.2682 4.16663 12.8029 4.43911C13.2734 4.67879 13.6558 5.06124 13.8955 5.53165C14.168 6.06643 14.168 6.76649 14.168 8.16663V11.8333C14.168 13.2334 14.168 13.9335 13.8955 14.4683C13.6558 14.9387 13.2734 15.3211 12.8029 15.5608C12.2682 15.8333 11.5681 15.8333 10.168 15.8333H5.66797C4.26784 15.8333 3.56777 15.8333 3.03299 15.5608C2.56259 15.3211 2.18014 14.9387 1.94045 14.4683C1.66797 13.9335 1.66797 13.2334 1.66797 11.8333V8.16663Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                ):(
                  <svg
                    width="20"
                    height="20"
                    fill="none"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke="white"
                      stroke-width="1.67"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M4.16699 10.0013H15.8337M15.8337 10.0013L10.0003 4.16797M15.8337 10.0013L10.0003 15.8346"
                    />
                  </svg>
                ),
                nospace: true,
              }}
          hierarchy={{
            type: "primary",
            buttonText:
              Props.test.status === constants.PROGRESS_STATUS.IN_PROGRESS &&
              Props.test.libtype === constants.libTypeIds.CODING_CHALLENGE
                ? "Resume test"
                : "Take test",
          }}
        />
      </div>
    </div>
  );
}
